import {
  GET_COMPANIES_SUCCESS,
  GET_COMPANIES_FAILURE,
  GET_COMPANIES_LOADING,
} from "../constants/actionTypes";

const INITIAL_STATE = {
  data: [],
  loading: true,
  error: null,
};

export default function companies(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_COMPANIES_LOADING:
      return { ...state, loading: true, data: [] };
    case GET_COMPANIES_SUCCESS:
      return { ...state, loading: false, data: action.payload.data };
    case GET_COMPANIES_FAILURE:
      return { ...state, loading: false, data: [] };
    default:
      return state;
  }
}
